import i18n from '../../i18n';
import store from '..';
import util from '@/util';
import atenaList from '@/services/atenaList.services';

const getDefaultState = () => ({
  fetch: false,
  status: '',
  error: '',
  info: JSON.parse(localStorage.getItem('info')),
  permissoes: JSON.parse(localStorage.getItem('permissions')),
  configEmpresa: JSON.parse(localStorage.getItem('configEmpresa')),
  userTimezone: '',
  appTimezone: ''
});

const state = getDefaultState();

if (state.info && state.info.idioma) {
  // Atualiza idioma após refresh
  i18n.locale = state.info.idioma;
}

export const getInfoUserEmpresa = (key = 'defesa') => {
  return store.state.user.info[`empresa__${key}`];
};

const mutations = {
  updateUserSessionData(state, data) {
    state.error = '';
    state.info = data.user;
    state.userTimezone = data.userTimezone;
    state.appTimezone = data.appTimezone;
    state.configEmpresa = JSON.parse(data.user.empresa__configuracao || '{}');
    state.permissoes = permissionsArray(data.permissions);
    state.info.idioma ? (i18n.locale = state.info.idioma) : (i18n.locale = 'pt-BR');
    state.info.empresa__id_template_odd = state.info.empresa__id_template_odd ?? 1;

    if (hasPermissaoNegocio(state.info.permissoes_negocio)) {
      const permissoes_negocio = JSON.parse(state.info.permissoes_negocio);
      const info = extractInfoPermissaoNegocio(permissoes_negocio);
      state.info.empresas = info.empresas;
      state.info.localidades = info.localidades;
      state.info.secoes = info.secoes;
    } else {
      if (state.info.empresas == null || state.info.empresas == ' ' || state.info.empresas == []) {
        state.info.empresas = state.info.id_empresa.toString();
      }
    }

    localStorage.setItem('userTimezone', data.userTimezone);
    localStorage.setItem('appTimezone', data.appTimezone);
    localStorage.setItem('info', JSON.stringify(state.info));
    localStorage.setItem('configEmpresa', data.user.empresa__configuracao || '{}');
    localStorage.setItem('permissions', JSON.stringify(permissionsArray(data.permissions)));
  },
  updateLogout(state) {
    removeUserSession();
    state = getDefaultState();
  },
  trocarEmpresa(state, empresa) {
    let info = {
      ...state.info,
      id_empresa: empresa.id_empresa,
      empresa__nome: empresa.nome_empresa,
      empresa__configuracao: empresa.empresa__configuracao,
      empresa__cotacao_maxima: empresa.cotacao_maxima_empresa,
      empresa__menu_avancado: empresa.menu_avancado,
      empresa__venda_pin: empresa.venda_pin,
      empresa__venda_api: empresa.venda_api,
      empresa__venda_bolao: empresa.venda_bolao,
      empresa__venda_eticket: empresa.venda_eticket,
      empresa__venda_slot: empresa.venda_slot,
      empresa__venda_me: empresa.venda_me,
      empresa__exibir_financeiro: empresa.exibir_financeiro,
      empresa__exibir_resultados: empresa.exibir_resultados,
      empresa__limite_maximo_venda: empresa.limite_maximo_venda,
      empresa__cotacao_favorito: empresa.cotacao_favorito,
      empresa__comissao_retida: empresa.comissao_retida,
      empresa__exibir_coluna_impresso: empresa.exibir_coluna_impresso,
      empresa__registrar_cliente: empresa.registrar_cliente,
      empresa__centro_de_custo: empresa.centro_de_custo,
      empresa__inverter_sinais_financeiro: empresa.inverter_sinais_financeiro,
      empresa__venda_atm: empresa.venda_atm,
      empresa__id_template_odd: empresa.id_template_odd ?? 1,
      empresa__deduzir_cancelamentos: empresa?.deduzir_cancelamentos ? true : false,
      empresa__permissoes: empresa?.permissoes ? empresa.permissoes : state.info?.empresa__permissoes
    };

    if (hasPermissaoNegocio(state.info.permissoes_negocio)) {
      const permissoes_negocio = JSON.parse(state.info.permissoes_negocio);
      const infoPermissao = extractInfoPermissaoNegocio(permissoes_negocio, empresa.id_empresa);
      info.localidades = infoPermissao.localidades;
      info.secoes = infoPermissao.secoes;
    }
    state.info = info;
    state.configEmpresa = empresa.configuracao_empresa;
    localStorage.setItem('info', JSON.stringify(info));
    localStorage.setItem('configEmpresa', JSON.stringify(empresa.configuracao_empresa));
    updateMoeda(state, empresa.configuracao_empresa);
  },
  trocarIdioma(state, idioma) {
    state.info.idioma = idioma;
    localStorage.setItem('info', JSON.stringify(state.info));
  },
  updateEmpresa(state, empresa) {
    let info = {
      ...state.info,
      empresa__nome: empresa.nome,
      empresa__configuracao: empresa.configuracao,
      empresa__cotacao_maxima: empresa.cotacao_maxima,
      empresa__menu_avancado: empresa.menu_avancado,
      empresa__venda_pin: empresa.venda_pin,
      empresa__venda_api: empresa.venda_api,
      empresa__venda_bolao: empresa.venda_bolao,
      empresa__limite_maximo_venda: empresa.limite_maximo_venda,
      empresa__cotacao_favorito: empresa.cotacao_favorito,
      empresa__registrar_cliente: empresa.registrar_cliente,
      empresa__centro_de_custo: empresa.centro_de_custo,
      empresa__inverter_sinais_financeiro: empresa.inverter_sinais_financeiro,
      empresa__venda_atm: empresa.venda_atm,
      empresa__id_template_odd: empresa.id_template_odd ?? 1
    };
    state.info = info;
    state.configEmpresa = empresa.configuracao;
    localStorage.setItem('info', JSON.stringify(info));
    localStorage.setItem('configEmpresa', JSON.stringify(empresa.configuracao));
    updateMoeda(state, empresa.configuracao);
  }
};

const updateMoeda = (state, config) => {
  if (config.moedaPadrao) {
    atenaList
      .getPaises({
        filter: `public.paises.detalhes->>'iso-4217' = '${config.moedaPadrao}'`,
        columns: 'detalhes',
        limit: 1
      })
      .then((res) => {
        state.info.empresa__paises_detalhes = res.data[0].detalhes;
        localStorage.setItem('info', JSON.stringify(state.info));
      })
      .catch((err) => {
        console.log(err);
        util.formWarn({
          msgTitle: 'Erro ao Carregar Dados',
          msgContent: 'Entre em contato com o Administrador do Sistema.',
          type: 'error'
        });
      });
  } else {
    state.info.empresa__paises_detalhes = undefined;
    localStorage.setItem('info', JSON.stringify(state.info));
  }
};

const removeUserSession = () => {
  localStorage.removeItem('info');
  localStorage.removeItem('permissions');
  localStorage.removeItem('configEmpresa');
};

const getEmpresa = (prefix, keys, obj) => {
  let empresa = {};
  keys.forEach((key) => {
    prefix ? (empresa[key] = obj[`${prefix}__${key}`]) : (empresa[key] = obj[`${key}`]);
  });
  return empresa;
};

const permissionsArray = (permissions) => {
  let arrPermissoes = [];
  for (const idx in permissions) {
    arrPermissoes.push(permissions[idx].id);
  }
  return arrPermissoes;
};

const extractInfoPermissaoNegocio = (data, changeEmpresa) => {
  let empresas = [];
  let localidades = null;
  let secoes = [];
  const idEmpresa = changeEmpresa ? changeEmpresa : state.info.id_empresa;
  data.forEach((item) => {
    if (item.hasOwnProperty('idEmpresa')) {
      empresas.push(item.idEmpresa);
      if (item.idEmpresa === idEmpresa && item.hasOwnProperty('localidades')) {
        localidades = item.localidades.map((localidade) => {
          if (localidade.secoes) secoes = secoes.concat(localidade.secoes);
          return localidade.id;
        });
      }
    }
  });

  return {
    empresas: empresas.toString(),
    localidades: localidades ? localidades.toString() : '',
    secoes: secoes.length > 0 ? secoes.toString() : ''
  };
};

const hasPermissaoNegocio = (data) => {
  return data && data != ' ' && JSON.parse(data).length > 0 ? true : false;
};

const actions = {
  registerUserSessionData({ commit }, response) {
    commit('updateUserSessionData', response);
  },
  logout({ commit }) {
    commit('updateLogout');
  },
  registerTrocarEmpresa({ commit }, empresa) {
    commit('trocarEmpresa', empresa);
  },
  registerTrocarIdioma({ commit }, idioma) {
    commit('trocarIdioma', idioma);
  },
  registerUpdateEmpresa({ commit }, empresa) {
    commit('updateEmpresa', empresa);
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
